import React, { useState } from "react";

const TrialPreRegisterPage = () => {
  const [email, setEmail] = useState("");

  const handleSubscribe = async () => {
    if (!email) {
      alert("メールアドレスを入力してください。");
      return;
    }

    // 仮保存（localStorage）
    localStorage.setItem("pendingEmail", email);

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/payment/create-checkout-session`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email,
          planType: "free", // トライアル
        }),
      });

      const data = await res.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        alert("セッション作成に失敗しました");
      }
    } catch (err) {
      console.error("Stripeエラー:", err);
      alert("エラーが発生しました");
    }
  };

  return (
    <div style={{ padding: "40px", maxWidth: "400px", margin: "0 auto", textAlign: "center" }}>
      <h2>AdSche 初回トライアル申し込み</h2>
      <p>メールアドレスを入力して、<br />
      30日間無料トライアルを開始してください。</p>

      <input
        type="email"
        placeholder="メールアドレス"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        style={{ padding: "10px", width: "100%", marginBottom: "20px", fontSize: "16px" }}
      />

      <button
        onClick={handleSubscribe}
        style={{ padding: "10px 30px", fontSize: "16px" }}
      >
        30日間無料で申し込む
      </button>

      <p style={{ fontSize: "14px", marginTop: "20px" }}>
        ※こちらは初回限定となります。
        <br />
        再利用をご希望の方は、
        <a
          href="https://buy.stripe.com/14A5kDeYf9v14EB3PP0kE01"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#0000EE", textDecoration: "underline" }}
        >
          コチラ
        </a>
        からお申し込みください。
      </p>
    </div>
  );
};

export default TrialPreRegisterPage;